import { Div } from '@positivote/design-system/components/Div'
import { LinkButton } from '@positivote/design-system/components/LinkButton'
import { Typography } from '@positivote/design-system/components/Typography'
import { ONE_POSITIVE_Z_INDEX } from '@positivote/design-system/constants'
import { useTheme } from '@positivote/design-system/hooks'
import { Breakpoint } from '@positivote/design-system/theme'

import { EducacionalGreyIcon } from '@/common/assets/custom-icons'
import { EducacionalLogo } from '@/common/assets/images'
import { openInNewTab } from '@/common/helpers'
import { i18n } from '@/common/i18n'

export interface BaseBackgroundProps {
  children: React.ReactNode
  logo?: React.ReactNode
  footer?: boolean
}

export function BaseBackground({ children, footer = true }: BaseBackgroundProps): JSX.Element {
  const { breakpoint } = useTheme()
  return (
    <Div
      className="BaseBackground-Container"
      css={{ display: 'flex', flex: 1, flexDirection: 'column' }}
    >
      <Div
        className="BaseBackground-Header"
        css={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '$lg' }}
      >
        <EducacionalLogo />
      </Div>
      <Div
        className="BaseBackground-Content"
        css={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          width: '100%',
          padding: '$none $lg',
          overflowY: 'auto',
          zIndex: ONE_POSITIVE_Z_INDEX,
          '& > *': { margin: 'auto' }
        }}
      >
        {children}
      </Div>
      {footer && (
        <Div
          className="BaseBackground-Footer"
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '$lg',
            gap: '$md',
            '@xs': { gap: '$2xs' }
          }}
        >
          <EducacionalGreyIcon css={{ width: 148, height: 24 }} />
          <Div
            css={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '$4xs',
              '@xs': { gap: '$5xs' }
            }}
          >
            <Typography
              variant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}
              css={{ color: '$on-surface-variant' }}
            >
              {i18n().common.layouts.baseBackground.footer.copyright}
            </Typography>
            <Div css={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <LinkButton
                onClick={() => openInNewTab('https://hub.educacional.com/termos.html')}
                typographyVariant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}
              >
                {i18n().common.layouts.baseBackground.footer.terms}
              </LinkButton>
              <Typography variant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}>
                |
              </Typography>
              <LinkButton
                onClick={() => openInNewTab('https://hub.educacional.com/privacidade.html')}
                typographyVariant={breakpoint === Breakpoint.xs ? 'labelSmall' : 'bodySmall'}
              >
                {i18n().common.layouts.baseBackground.footer.privacy}
              </LinkButton>
            </Div>
          </Div>
        </Div>
      )}
    </Div>
  )
}
